export const QUERY_KEYS = {
  // User
  USER_DETAIL: ['user', 'detail'],

  // Device
  DEVICE_DATA: (deviceId, startTime, endTime, sensorType) => [
    'device',
    'data',
    deviceId,
    startTime,
    endTime,
    sensorType,
  ],
  DEVICE_DATA_ALL: ['device'],
  DEVICE_PARAMETER: (eui) => ['device-parameter', eui],
  DEVICE_PARAMETER_ALL: ['device-parameter', 'all'],

  // Tenant
  TENANT_BASE: ['tenant'],
  TENANT_LIST: (page, size, name) => ['tenant', 'list', page, size, name],
  TENANT_DETAIL: (tenantId) => ['tenant', 'detail', tenantId],
  TENANT_ALL: (name) => ['tenant', 'all', name],

  // Tenant Members
  MEMBER_LIST: (page, size) => ['member', 'list', page, size],
  MEMBER_SEARCH: (filters) => ['member', 'search', filters],
  MEMBER_DETAIL: (memberId) => ['member', 'detail', memberId],
  MEMBER_ALL: ['member'],

  // Gateway
  GATEWAY_LIST: (page, size) => ['gateway', 'list', page, size],
  GATEWAY_SEARCH: (filters) => ['gateway', 'search', filters],
  GATEWAY_DETAIL: (gatewayId) => ['gateway', 'detail', gatewayId],
  GATEWAY_ALL: ['gateway'],
  GATEWAYS_LIST: (page, size) => ['gateways', 'list', page, size],

  // Device
  DEVICE_LIST: (page, size) => ['device', 'list', page, size],
  DEVICE_SEARCH: (filters) => ['device', 'search', filters],
  DEVICE_DETAIL: (deviceId) => ['device', 'detail', deviceId],
  DEVICE_ALL: ['device'],
  DEVICES_LIST: (page, size) => ['devices', 'list', page, size],

  // Applications
  APPLICATIONS_LIST: ['applications', 'list'],

  // Profile Templates
  PROFILE_TEMPLATES: ['profile', 'templates'],

  // Dashboard & Folders
  FOLDERS_LIST: (page, size, name, tenantId) => [
    'folders',
    'list',
    page,
    size,
    name,
    tenantId,
  ],
  FOLDERS_ALL: ['folders'],

  DASHBOARD_LIST: (folderId, name, page, size, tenantId) => [
    'dashboard',
    'list',
    folderId,
    name,
    page,
    size,
    tenantId,
  ],
  DASHBOARD_DETAIL: (dashboardId) => ['dashboard', 'detail', dashboardId],
  DASHBOARD_BY_DEVICE: (tenantId, deviceEui) => [
    'dashboard',
    'by-device',
    tenantId,
    deviceEui,
  ],
  DASHBOARD_ALL: ['dashboard'],
  DASHBOARD_GLOBAL: ['dashboard', 'global'],

  // Channel
  CHANNEL_LIST: (name, isActive, channelTypeId, page, pageSize) => [
    'channel',
    'list',
    name,
    isActive,
    channelTypeId,
    page,
    pageSize,
  ],
  CHANNEL_DETAIL: (channelId) => ['channel', 'detail', channelId],
  CHANNEL_TYPE_LIST: ['channel', 'type', 'list'],
  CHANNEL_TYPE_FIELDS: (channelTypeId) => [
    'channel',
    'type',
    'fields',
    channelTypeId,
  ],
  CHANNEL_ALL: ['channel'],

  // Rules
  RULES_LIST: (name, targetType, severity, isActive, page, pageSize) => [
    'rules',
    'list',
    name,
    targetType,
    severity,
    isActive,
    page,
    pageSize,
  ],
  RULES_DETAIL: (ruleId) => ['rules', 'detail', ruleId],
  RULES_ALL: ['rules'],

  // Alert
  ALERT_LIST: (status, page, pageSize, targetEui, startTime, endTime) => [
    'alert',
    'list',
    status,
    page,
    pageSize,
    targetEui,
    startTime,
    endTime,
  ],
  ALERT_ALL: ['alert'],

  // Message / Outbox
  MESSAGE_LIST: (page, size, channelType, status, recipient) => [
    'message',
    'list',
    page,
    size,
    channelType,
    status,
    recipient,
  ],
  MESSAGE_DETAIL: (messageId) => ['message', 'detail', messageId],
  MESSAGE_ALL: ['message'],

  // Billing
  BILLING_PLANS: ['billing', 'plans'],
  BILLING_SUBSCRIPTION: (tenantId) => ['billing', 'subscription', tenantId],
  BILLING_INVOICES: (tenantId) => ['billing', 'invoices', tenantId],
  BILLING_PAYMENTS: (tenantId) => ['billing', 'payments', tenantId],
  BILLING_CREDIT: (tenantId) => ['billing', 'credit', tenantId],
  BILLING_CREDIT_TRANSACTIONS: (tenantId) => [
    'billing',
    'credit-transactions',
    tenantId,
  ],
  BILLING_CREDIT_USAGE: (tenantId, days, page, pageSize) => [
    'billing',
    'credit-usage',
    tenantId,
    days,
    page,
    pageSize,
  ],

  // Tags
  TAG_LIST: (page, size, name) => ['tag', 'list', page, size, name],
  TAG_DETAIL: (tagId) => ['tag', 'detail', tagId],
  TAG_ALL: ['tag'],
};
